export default "__VITE_ASSET__DCy_Z2LI__"